<div class="container">
    <div class="card">
        <div class="card-header">
            <h2>{{ 'MENU.DASHBOARD.add_partners' | translate }}</h2>
            <i class="fas fa-handshake"></i>
        </div>
        
        <div class="card-body">
            <form id="partnerForm" (ngSubmit)="onSubmit()">
                <div class="form-step">
                    <div class="step-number mx-1">1</div>
                    <div class="step-text"> {{ 'MENU.DASHBOARD.partner_information' | translate }}</div>
                </div>
                
                <div class="row">
                    <!-- 🖼️ Logo Upload -->
                    <div class="col-3">
                        <div class="form-group">
                            <label class="form-label required-field">{{ 'MENU.DASHBOARD.partner_logo' | translate }}</label>
                           
                            <div class="file-upload-container">
                                <input type="file" id="logoUpload" accept="image/*" (change)="onFileSelected($event)" #fileInput>
                                <div class="file-upload-label">
                                    <i class="fas fa-cloud-upload-alt file-upload-icon" style="color: #cca44c;"></i>
                                    <div class="file-upload-text">{{ 'MENU.DASHBOARD.click_to_upload_logo' | translate }}</div>
                                    <div class="file-upload-text"> {{ 'MENU.DASHBOARD.drag_drop_image' | translate }}</div>
                                    <div class="form-hint">{{ 'MENU.DASHBOARD.recommended_size' | translate }}</div>
                                </div>
                            </div>

                            <!-- معاينة الصورة الحالية -->
                            <div class="preview-container" *ngIf="showCurrentLogo">
                                <div class="preview-header">
                                    <span class="preview-title">{{ 'MENU.DASHBOARD.current_logo' | translate }}</span>
                                </div>
                                <img [src]="partner.logo" class="logo-preview" alt="Current Logo">
                                <div class="preview-actions mt-2">
                                    <button type="button" class="btn btn-outline btn-sm" (click)="removeCurrentLogo()">
                                        <i class="fas fa-trash me-1"></i> {{ 'MENU.DASHBOARD.remove_current' | translate }}
                                    </button>
                                </div>
                            </div>

                            <!-- معاينة الصورة الجديدة -->
                            <div class="preview-container" *ngIf="previewUrl">
                                <div class="preview-header">
                                    <span class="preview-title">{{ 'MENU.DASHBOARD.new_logo_preview' | translate }}</span>
                                </div>
                                <img [src]="previewUrl" class="logo-preview" alt="New Logo Preview">
                            </div>
                            
                            <!-- لا توجد صورة -->
                            <div class="no-preview" *ngIf="!showCurrentLogo && !previewUrl">
                                <div class="no-preview-content">
                                    <i class="fas fa-image no-preview-icon"></i>
                                    <div class="form-hint"> {{ 'MENU.DASHBOARD.no_logo_uploaded' | translate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 📝 Partner Info -->
                    <div class="col-8 mx-1">
                        <div class="field-group">
                            <div class="row">
                                <!-- Name Arabic -->
                                <div class="col-12">
                                    <label class="form-label required-field">{{ 'MENU.DASHBOARD.name_ar' | translate }}</label>
                                    <input type="text" class="form-control" id="partnerNameAr" 
                                           placeholder="{{ 'MENU.DASHBOARD.name_ar' | translate }}" 
                                           [(ngModel)]="partner.name_ar" name="name_ar" required dir="rtl">
                                </div>
                            </div>
                            
                            <div class="row mt-3">
                                <!-- Name English -->
                                <div class="col-12">
                                    <label class="form-label required-field">{{ 'MENU.DASHBOARD.name_en' | translate }}</label>
                                    <input type="text" class="form-control" id="partnerNameEn" 
                                           placeholder="{{ 'MENU.DASHBOARD.name_en' | translate }}" 
                                           [(ngModel)]="partner.name_en" name="name_en" required dir="ltr">
                                </div>
                            </div>
                        </div>
                        
                        <div class="row mt-3">
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="form-label required-field">{{ 'MENU.DASHBOARD.partner_url' | translate }}</label>
                                    <div class="input-group">
                                        <input type="url" class="form-control" id="partnerUrl" placeholder="https://example.com" 
                                               [(ngModel)]="partner.url" name="url" required>
                                    </div>
                                    <div class="form-hint"> {{ 'MENU.DASHBOARD.enter_full_url' | translate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- 📝 Description Arabic -->
                <div class="form-group mt-4">
                    <label class="form-label">{{ 'MENU.DASHBOARD.description_ar' | translate }}</label>
                    <textarea
                        class="form-control"
                        id="partnerDescriptionAr"
                        rows="4"
                        [(ngModel)]="partner.description_ar"
                        name="description_ar"
                        placeholder="{{ 'MENU.DASHBOARD.write_short_description_partner_ar' | translate }}"
                        dir="rtl"
                    ></textarea>
                </div>

                <!-- 📝 Description English -->
                <div class="form-group mt-3">
                    <label class="form-label">{{ 'MENU.DASHBOARD.description_en' | translate }}</label>
                    <textarea
                        class="form-control"
                        id="partnerDescriptionEn"
                        rows="4"
                        [(ngModel)]="partner.description_en"
                        name="description_en"
                        placeholder="{{ 'MENU.DASHBOARD.write_short_description_partner_en' | translate }}"
                        dir="ltr"
                    ></textarea>
                </div>

                <div class="success-message" id="successMessage">
                    <i class="fas fa-check-circle"></i>
                    <span>{{ 'MENU.DASHBOARD.partner_added_success' | translate }}</span>
                </div>
                
                <div class="form-actions">
                    <button type="submit" class="btn" id="submitBtn" style="background-color: #cca44c !important; color: #fff;">
                       {{ 'MENU.DASHBOARD.partner_add_button' | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>